import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic_token_lrc",
  "use": "ic_token_lrc-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic_token_lrc\">\n<path d=\"M0 16C0 7.16343 7.16343 0 16 0C24.8366 0 32 7.16343 32 16C32 24.8366 24.8366 32 16 32C7.16343 32 0 24.8366 0 16Z\" fill=\"white\" />\n<path d=\"M20.3794 15.9541H30.1714V16.0325L14.8617 25.4432L22.4777 19.3263L20.3794 15.9541ZM14.6285 6.85718V25.6L6.85712 19.3263L14.6285 6.85718Z\" fill=\"#1C60FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol